import {RequestGateway, RequestOptions} from './request-gateway';
import {HttpClient} from '@angular/common/http';
import {ElementRef, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {HandlerRegistry} from "./handler-registry.service";
import {HandlerInvoker, HandlerOptions} from './handler';
import {take} from "rxjs/operators";
import {AppContext} from "../../app-context";

@Injectable()
export class QueryGateway extends RequestGateway {
  protected static invokers: Map<string, HandlerInvoker[]> = new Map();

  constructor(protected registry: HandlerRegistry, http: HttpClient) {
    super(QueryGateway.invokers, registry, http, '/api/query');
  }

  subscribe(type: string, payload: any, options: RequestOptions = {caching: true, showSpinner: false}, elementRef?: ElementRef<Element>): Subject<any> {
    const startTime = Date.now();
    const subject = new ReplaySubject(1);
    const innerSubject = super.send(type, payload, options, elementRef) as Subject<any>;
    if (!innerSubject.unsubscribe) {
      innerSubject.unsubscribe = () => {};
    }
    innerSubject.subscribe({
      next: (n) => {
        const endTime = Date.now();
        subject.next(n);
        if (AppContext.environment === "localhost") {
          console.debug(`Execution time for subscribe: ${type} ${endTime - startTime}ms`);
        }
      },
      // Without this, an error from the underlying request (surfaced via RequestGateway.send()'s own
      // `tap({error: ...})`, unless `hideError` is set) was never forwarded to the outer `subject` -
      // callers of `subscribeTo`/`QueryGateway.subscribe` (e.g. `sendFacetsQuery`) would see the
      // returned Observable simply never emit `next`, `error`, or `complete` on failure, hanging
      // silently forever instead of terminating with the real error.
      error: (e) => subject.error(e)
    });
    return subject;
  }

  override send(type: string, payload: any, options: RequestOptions = {caching: true, showSpinner: false}, elementRef?: ElementRef<Element>): Observable<any> {
    return super.send(type, payload, options, elementRef).pipe(take(1));
  }

  static registerHandlerInvoker(target: any, eventName: string, handler: Function, options?: HandlerOptions) {
    this.addInvoker(this.invokers, target, eventName, handler, 'query', options);
  }
}
